/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import Component from 'can/component/component';
import template from './card.stache';
import cloudinaryUtil from 'scripts/utils/cloudinary';

Component.extend({
    tag: 'timeline-card',
    template: template,
    leakScope: false,
    viewModel: {
        define: {
            imageSrc: {
                get() {
                    const image = this.attr('coverImage');
                    return cloudinaryUtil.getCloudinaryPath(
                        image.identifier,
                        image.width,
                        image.height,
                        image.crop,
                    );
                },
            },
            renderCard: {
                type: 'boolean',
                value: false,
            },
        },
    },
    helpers: {
        collectionClass(options) {
            const collectionTags = options.context['collectionTags'];
            return collectionTags && collectionTags.length
                ? collectionTags[0].toLowerCase().replace(' ', '-')
                : null;
        },
        collectionIcon(options) {
            const collectionTags = options.context['collectionTags'];
            if (collectionTags && collectionTags.length) {
                switch (collectionTags[0]) {
                    case 'Iconic Venues':
                        return 'sprites.svg#icon-tee';
                    case 'Legendary Champions':
                        return 'sprites.svg#icon-trophy';
                    case 'Signature Moments':
                        return 'sprites.svg#icon-star';
                }
            }
            return null;
        },
        collectionName(options) {
            const collectionTags = options.context['collectionTags'];
            return collectionTags && collectionTags.length
                ? collectionTags[0]
                : null;
        },
    },
    events: {
        inserted() {
            const $parent = this.element.parent('.swiper-slide');
            $parent.css('width', '').css('height', '');
        },
        removed() {
            const $parent = this.element.parent('.swiper-slide');
            $parent.width($parent.width()).height($parent.height());
        },
    },
});
